import { Component, OnDestroy } from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';

import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

import { IApplicationState } from '../../../stateManagement/states/applicationState';
import { IAuthenticationDataState } from '../../../stateManagement/states/dataState';
import * as authenticationTypes from '../../types';
import * as fromRoot from '../../../stateManagement/rootReducer';
import { ServerUpdatePasswordAction } from '../../../stateManagement/actions/data/authentication';
import { IToastr, IPortalInfo, MessageType, IMessage } from '../../../shared/types';
import * as _ from 'lodash';
import { go, replace, search, show, back, forward } from '@ngrx/router-store';

@Component({
  selector: 'tr-update-password-container',
  templateUrl: './update-password-container.component.html',
  //styleUrls: ['./update-password-container.component.scss']
})
export class UpdatePasswordContainerComponent implements OnDestroy {
  subscriptions: Array<Subscription> = [];
  isBusy$: Observable<boolean>;
  message$: Observable<IMessage>;
  isNewUser$: Observable<boolean>;
  portalInfo$: Observable<IPortalInfo>;
  currentAccount$: Observable<authenticationTypes.IAccount>;

  constructor(
    private store: Store<IApplicationState>,
    private router: Router
  ) {
    this.isBusy$ = this.store.select(fromRoot.isApplicationBusy);
    this.message$ = this.store.select(fromRoot.getAuthenticationStatusForRegisterdUser);
    this.isNewUser$ = this.store.select(fromRoot.getAuthenticationIsNewRegisterUser);
    this.portalInfo$ = this.store.select(fromRoot.getApplicationPortalInformation);
    this.currentAccount$ = this.store.select(fromRoot.getAuthenticationAccount);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  updatePassword(updateData: authenticationTypes.IUpdatePassword): void {
    this.store.dispatch(new ServerUpdatePasswordAction(updateData));
    this.subscriptions.push(
      this.store.select(fromRoot.getAuthenticationDataState)
        .subscribe( (state: IAuthenticationDataState) => {
          // if user is authenticated and NOT a new user
          // And isUserStatusChanged = true;
          const autoNavigateAway = (!state.isNewRegisterUser && state.isUserStatusChanged) || (!state.isNewRegisterUser && !state.isUserStatusChanged && state.status && state.status.type === MessageType.INFO);
          if (autoNavigateAway) {
            if (state.isMFAEnabled && !state.isMFAAuthenticated) {
              this.router.navigate(['/authentication/mfaAuthentication']);
            } 
            else {
              window.location.href = '/';
            }
          }
        })
    );
  }

  onCancel(event: string) {
    this.store.dispatch(back());
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/containers/update-password-container/update-password-container.component.ts